import Borders from '@dynatrace/strato-design-tokens/borders';
import Colors from '@dynatrace/strato-design-tokens/colors';

/**
 * Base style for the full-height vertical divider on pinned column edges.
 * Left pinned columns add `right: 0`; right pinned columns add `left: 0`.
 */
export const pinnedColumnDividerBase = {
  content: '""',
  display: 'block',
  position: 'absolute',
  width: Borders.Width.Default,
  top: 0,
  bottom: 0,
  backgroundColor: Colors.Border.Neutral.Default,
  maxWidth: '100%',
} as const;
